import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AuctionMessage } from "@shared/services/alert-message/alert-message.model";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";

@Component({
	selector: "app-create-auction-dialog",
	templateUrl: "./create-auction-dialog.component.html",
	styleUrl: "./create-auction-dialog.component.scss",
	standalone: false
})
export class CreateAuctionDialogComponent {
	constructor(
		public utils: ClickarUtilsService,
		public dialogRef: MatDialogRef<CreateAuctionDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: AuctionMessage
	) { }

	/* onNoClick(): void {
		this.dialogRef.close("");
	} */

	close() {
		this.dialogRef.close("");
	}

	ok() {
		this.dialogRef.close("ok");
	}
}